<template>
  <div id="app" style="background:#f0f2f5;min-height:100vh;">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp :mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp :mesaj="text1" v-model="snackbar" :color="snackbarkColor"></snackbarcomp>
    <doviz ref="doviz" @setCurrencyValue="setCurrency($event)"></doviz>

    <!-- 3D Onay Dialog -->
    <v-dialog v-model="threedConfirmDialog" max-width="440px" persistent>
      <v-card style="border-radius:16px;overflow:hidden;">
        <div style="background:#fff7ed;padding:28px 24px;text-align:center;">
          <v-icon size="52" color="orange darken-2">warning</v-icon>
          <div style="font-size:18px;font-weight:700;color:#1f2937;margin-top:12px;">{{ $t('3D-Payment-Confirmation') }}</div>
          <div style="color:#6b7280;margin-top:8px;line-height:1.5;">
            {{ $t('From-Your-Card-Without-3D-Confirmation') }}
            <div style="font-size:26px;font-weight:700;color:#ef4444;margin-top:8px;">
              {{ footerTotalFare | moneyformat }} ₺
            </div>
            {{ $t('Will-Be-Charged-Do-You-Approve') }}
          </div>
        </div>
        <v-card-actions style="padding:12px 20px 20px;gap:8px;display:flex;">
          <v-btn flat block @click="threedConfirmDialog = false"
            style="border:2px solid #d1d5db;color:#4b5563;border-radius:10px;height:44px;">
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn block @click="creditCardPayment()"
            style="background:#ef4444;color:#fff;border-radius:10px;height:44px;font-weight:600;">
            <v-icon left small>check</v-icon>{{ $t('I-Confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Kredi Kartı Dialog -->
    <v-dialog v-model="creditCardInfo" persistent max-width="760px">
      <v-card style="border-radius:20px;overflow:hidden;">
        <div
          style="background:linear-gradient(135deg,#667eea,#764ba2);padding:18px 24px;display:flex;align-items:center;justify-content:space-between;">
          <div style="display:flex;align-items:center;gap:8px;color:#fff;">
            <v-icon color="white">credit_card</v-icon>
            <span style="font-size:16px;font-weight:600;">{{ $t('Hotel-Pay-By-Card') }}</span>
          </div>
          <div style="color:#fff;text-align:right;">
            <div style="font-size:11px;opacity:0.7;">{{ $t('totalamount') }}</div>
            <div style="font-size:24px;font-weight:700;">{{ footerTotalFare | moneyformat }} ₺</div>
          </div>
        </div>

        <div v-if="priceChanged"
          style="background:#fef2f2;border-left:4px solid #ef4444;padding:10px 20px;display:flex;align-items:center;gap:8px;">
          <v-icon color="red" small>info</v-icon>
          <span style="color:#ef4444;font-size:13px;font-weight:600;">
            {{ $t('pricechanged') }}! : {{ footerTotalFare | moneyformat }} ₺
          </span>
        </div>

        <v-card-text style="padding:24px;">
          <v-layout row wrap>
            <!-- Kart Önizleme -->
            <v-flex xs12 sm5 pr-3>
              <div class="cc-card-preview">
                <div class="cc-chip-icon"></div>
                <div class="cc-number-display">{{ cardNumberDisplay }}</div>
                <div class="cc-bottom-row">
                  <div>
                    <div class="cc-meta-label">{{ $t('Card-Holder') }}</div>
                    <div class="cc-meta-value">{{ PaymentForm.CardHolder || '•••• ••••' }}</div>
                  </div>
                  <div style="text-align:right;">
                    <div class="cc-meta-label">{{ $t('Card-Expiry') }}</div>
                    <div class="cc-meta-value">{{ PaymentForm.ExpirationMonth || 'MM' }}/{{ paymentYearDisplay || 'YY' }}
                    }}</div>
                  </div>
                </div>
              </div>
            </v-flex>
            <!-- Kart Formu -->
            <v-flex xs12 sm7>
              <v-form ref="formodeme" v-model="validOdeme" lazy-validation>
                <v-text-field v-model="PaymentForm.CardNumber" :rules="[rules.required]" :label="$t('Card-Number')" outline
                  mask="#### #### #### ####"></v-text-field>
                <v-text-field v-model="PaymentForm.CardHolder" :rules="[rules.required]" :label="$t('Card-Holder-Name')"
                  outline></v-text-field>
                <v-layout row wrap>
                  <v-flex xs6 pr-1>
                    <v-select :items="sonkullanimAy" :label="$t('Card-Expiry')" v-model="PaymentForm.ExpirationMonth"
                      :rules="[rules.required]" item-text="text" item-value="id" outline></v-select>
                  </v-flex>
                  <v-flex xs6 pl-1>
                    <v-select :items="sonkullanimYil" v-model="PaymentForm.ExpirationYear" :label="$t('Card-Expiry')"
                      :rules="[rules.required]" outline></v-select>
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field :label="$t('Card-CVC')" v-model="PaymentForm.Cvv" :rules="[rules.required]" outline
                      mask="####"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions style="padding:8px 24px 20px;display:flex;">
          <v-btn flat @click="closeCreditCardDialog()"
            style="color:#4b5563;border:2px solid #e5e7eb;border-radius:10px;height:44px;">
            {{ $t('Cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="confirmthereed()"
            style="background:linear-gradient(135deg,#667eea,#764ba2);color:#fff;border-radius:10px;height:44px;font-weight:600;padding:0 28px;">
            <v-icon left>credit_card</v-icon>{{ $t('Confirm-Payment') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Cari Onay Dialog -->
    <v-dialog v-model="currentPayInfo" persistent max-width="440px">
      <v-card style="border-radius:16px;overflow:hidden;">
        <div style="padding:28px 24px;text-align:center;">
          <v-icon size="52" color="#10b981">account_balance_wallet</v-icon>
          <div style="font-size:18px;font-weight:700;color:#1f2937;margin-top:12px;">{{ $t('Payment-From-Account') }}</div>
          <div style="color:#6b7280;margin-top:6px;" v-html="$t('Transfer-Current-Payment-Confirm', { price: footerTotalFare | moneyformat, searchCurrency: searchCurrency })"></div>

          <div v-if="priceChanged"
            style="margin-top:12px;background:#fef2f2;border-left:4px solid #ef4444;padding:10px 14px;border-radius:8px;text-align:left;">
            <v-icon color="red" small>info</v-icon>
            <span style="color:#ef4444;font-weight:600;font-size:13px;">
              {{ $t('pricechanged') }}! : {{ footerTotalFare | moneyformat }} {{ searchCurrency }}
            </span>
          </div>

          <div style="margin-top:20px;">
            <div style="font-size:11px;color:#9ca3af;">{{ searchCurrency }}</div>
            <div style="font-size:38px;font-weight:700;color:#667eea;line-height:1.1;">
              {{ footerTotalFare | moneyformat }}
              <span style="font-size:18px;color:#9ca3af;">{{ searchCurrency }}</span>
            </div>
          </div>
        </div>
        <v-card-actions style="padding:0 20px 20px;display:flex;gap:8px;">
          <v-btn flat block @click="closeCurrentPaymentDialog()"
            style="border:2px solid #e5e7eb;color:#6b7280;border-radius:10px;height:44px;">
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn block @click="makePayment()"
            style="background:#10b981;color:#fff;border-radius:10px;height:44px;font-weight:600;">
            <v-icon left small>check_circle</v-icon>{{ $t('Approve') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ana İçerik -->
    <div v-show="!loadingvmodel">
      <v-form ref="formTicket" v-model="valid">
        <div style="max-width:90%;margin:0 auto;padding:16px;">

          <!-- Header Kartı -->
          <div class="page-header-card">
            <div>
              <div style="font-size:22px;font-weight:600;">{{ $t('Passenger-Details') }}</div>
            </div>
            <div v-if="PnrNo" class="pnr-chip-badge">PNR: {{ PnrNo }}</div>
          </div>

          <v-layout row wrap>
            <!-- SOL KOLON: Formlar -->
            <v-flex xs12 md8 pr-2>

              <!-- Yolcu Kartları -->
              <PassengerCard v-for="(paxs, ind) in paxList" :key="'pax-' + ind" :pax="paxs" :index="ind"
                :isUpdate="isUpdate || disabled" :contactValue.sync="contactValueList[ind]" :genderItems="genderItems"
                :countryItems="countryItems" :WheelChairItems="WheelChairItems" :isInternational="isInternational"
                :rules="rules" @defaultContact="defaultContact" @changeFirstName="changeFirstName"
                @changeLastName="changeLastName" @changeEmail="changeEmail" @changePhone="changePhone"
                @updatePassenger="updatePassengerAdres" />

              <!-- İletişim Kartı -->
              <div class="section-card contact-card" v-if="ticketAllocate.length > 0">
                <div class="card-header green-bar">
                  <div style="display:flex;align-items:center;gap:8px;">
                    <v-icon color="#10b981">contacts</v-icon>
                    <span style="font-size:15px;font-weight:600;color:#1f2937;">{{ $t('Contact-Information') }}</span>
                  </div>
                </div>
                <div class="card-body">
                  <v-layout row wrap>
                    <v-flex xs12 sm3 pr-1>
                      <v-text-field :label="$t('Name_label')" :disabled="isUpdate || disabled"
                        v-model="updatePassengerItem.Contact.Name" :rules="[rules.required]" outline></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 pr-1>
                      <v-text-field :label="$t('Surname_label')" :disabled="isUpdate || disabled"
                        v-model="updatePassengerItem.Contact.LastName" :rules="[rules.required]" outline></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 pr-1>
                      <v-text-field :label="$t('Telephone')" :disabled="isUpdate || disabled"
                        v-model="updatePassengerItem.Contact.Phone" :rules="[rules.required]" outline></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                      <v-text-field :label="$t('Email_label')" :disabled="isUpdate || disabled"
                        v-model="updatePassengerItem.Contact.Email" :rules="[rules.required]" outline></v-text-field>
                    </v-flex>
                  </v-layout>
                </div>
              </div>

              <!-- Fatura Kartı -->
              <div class="section-card invoice-card" v-if="ticketAllocate.length > 0">
                <div class="card-header amber-bar">
                  <div style="display:flex;align-items:center;gap:8px;">
                    <v-icon color="#f59e0b">receipt</v-icon>
                    <span style="font-size:15px;font-weight:600;color:#1f2937;">{{ $t('Invoice-Details') }}</span>
                  </div>
                </div>
                <div class="card-body">
                  <caricomp v-model="cariItem" v-bind:zorunlumu="true" :aktifmi="isUpdate || disabled"></caricomp>
                </div>
              </div>

              <!-- Not Kartı -->
              <div class="section-card notes-card" v-if="ticketAllocate.length > 0">
                <div class="card-header grey-bar">
                  <div style="display:flex;align-items:center;gap:8px;">
                    <v-icon color="#6b7280">note</v-icon>
                    <span style="font-size:15px;font-weight:600;color:#1f2937;">{{ $t('Note') }}</span>
                  </div>
                </div>
                <div class="card-body">
                  <v-textarea :label="$t('Reservation-Note')" v-model="updatePassengerItem.Notes" outline
                    :disabled="isUpdate" rows="3" hide-details></v-textarea>
                </div>
              </div>
            </v-flex>

            <!-- SAĞ KOLON: Sidebar -->
            <v-flex xs12 md4>
              <FlightSidebar :ticketAllocate="ticketAllocate" :ticketAllocateReady="ticketAllocateReady"
                :IsBooking="IsBooking" :isUpdate="isUpdate" :loadingvmodel="loadingvmodel" :IsCancelable="IsCancelable"
                :nextStatu="nextStatu" :Provider="Provider" :ShoppingCard="ShoppingCard"
                :footerTotalFare="footerTotalFare" :searchCurrency="searchCurrency" @downloadPdf="downloadPdf" @updatePassenger="updatePassenger"
                @updatePassengerCard="updatePassengerCard" @cancelReservation="cancelReservation"
                @startPaymentWithPrebook="startPaymentWithPrebook" @sendNextTicket="sendNextTicket"
                @goNextTicket="goNextTicket" />
            </v-flex>
          </v-layout>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import PassengerCard from "./islem_components/PassengerCard.vue";
import FlightSidebar from "./islem_components/FlightSidebar.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import phoneinput from "../../customcomp/PhoneInputNew.vue";
import auth from "@/api/auth.js";
import logoo from "@/assets/control.js";
import Airports from "@/components/app/satis/ucak/airports.js";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import doviz from "@/components/app/muhasebe/comp/doviz.vue";
import tool from "../../coper/tools";
import { resolvePriceField } from "../comp/ucak/comp/fareCurrency.js";

export default {
  data() {
    return {
      nextStatu: false,
      ShoppingCard: null,
      snackbarkColor: "success",
      threedConfirmDialog: false,
      pdfactive: false,
      isInternational: false,
      prmAcenteKodu: "",
      itemsproviders: [],
      IsBooking: false,
      validOdeme: true,
      step: 0,
      disabled: false,
      typeOfPayment: 0,
      sonkullanimAy: [
        { id: "01", text: "1" }, { id: "02", text: "2" }, { id: "03", text: "3" },
        { id: "04", text: "4" }, { id: "05", text: "5" }, { id: "06", text: "6" },
        { id: "07", text: "7" }, { id: "08", text: "8" }, { id: "09", text: "9" },
        { id: "10", text: "10" }, { id: "11", text: "11" }, { id: "12", text: "12" },
      ],
      sonkullanimYil: ["2025", "2026", "2027", "2028", "2029", "2030", "2031", "2032", "2033", "2034", "2035"],
      creditCardInfo: false,
      PaymentForm: {
        CardHolder: null,
        CardNumber: null,
        CardType: "Visa",
        Cvv: null,
        ExpirationYear: null,
        ExpirationMonth: null,
        ExtraAmount: 0,
        InstallmentId: null,
        InstallmentCount: 1,
        Currency: "TRY",
      },
      priceChanged: false,
      currentPayInfo: false,
      rules: {
        exactLength11: (v) => (v && v.length === 11) || "TCK 11 karakter olmalıdır",
        required: (v) => !!v || this.$t("Mandatory-Areas"),
        email: (v) => {
          const p = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return p.test(v) || this.$t("Wrong-e-mail");
        },
      },
      valid: true,
      cariItem: null,
      billingInformationItem: Airports.billingInformation(),
      makePrebookingItem: Airports.makePrebooking(),
      finalizeShoppingItem: Airports.finalizeShopping(),
      updatePassengerItem: Airports.updatePassengers(),
      WheelChairItems: Airports.wheelChairs(),
      countryItems: Airports.countiries(),
      genderItems: Airports.Genders(),
      makePaymentItem: Airports.makePayment(),
      nextTicket: Airports.nextTicket(),
      text1: null,
      snackbar: false,
      loadingvmodel: true,
      ticketAllocate: [],
      passengerList: [],
      paxList: [],
      footerBaseFare: 0,
      footerTotalTax: 0,
      footerTotalServiceFee: 0,
      footerLateInterest: 0,
      footerTotalMarkupFare: 0,
      footerTotalMarkupFareList: 0,
      footerTotalFare: 0,
      sayfayetki: { Screen: false, Update: false, Save: false, Delete: false, Status: false, Message: null, islem: 0 },
      PnrNo: "",
      Provider: "",
      flightType: null,
      CurrentCode: null,
      isContactDefault: -1,
      contactValueList: [false, false, false, false, false, false, false, false, false, false],
      currencyValue: 0,
      searchCurrency: 'TRY',
      isUpdate: false,
      IsCancelable: false,
      ListInput: {
        SirketKodu: null,
        BaslangicTarihi: null,
        BitisTarihi: null,
        Carikod: null,
        HavaYoluKodu: null,
        FormNo: null,
        BiletNo: null,
        TextSearch: null,
        Paging: { SayfaNo: null, VeriAdet: 50, SiralamaTip: 0 },
        Filtreler: {
          CariKod: null, Havayollari: [], Parkurlar: [], HatTipi: [],
          BiletTipi: "S", Ucus1: null, Ucus2: null, KesenKisi: null,
          PosKod: null, DekontBas: false, KrediKartNo: null,
          GiderPusulasi: 0, AcentaFatNo: 0, IadeFatura: false,
          SifirTutarGosterme: false, RezVerenBosGoster: false,
          GeciciCari: 0, FaturaStatus: 0, BaslangicTutar: 0,
          BitisTutar: 0, YolcuAdi: null, PnrNo: null,
          TutarTip: 0, BiletAcenteTipi: 0,
        },
      },
      prebookingDone: false,
      passengersLocked: false,
      paymentInfo: null
    };
  },

  computed: {
    ticketAllocateReady() {
      return (
        Array.isArray(this.ticketAllocate) &&
        this.ticketAllocate.length > 0 &&
        this.ticketAllocate[0] &&
        Array.isArray(this.ticketAllocate[0].FlightSegments)
      );
    },
    cardNumberDisplay() {
      if (!this.PaymentForm.CardNumber) return "•••• •••• •••• ••••";
      const n = this.PaymentForm.CardNumber.replace(/\D/g, "").padEnd(16, "•");
      return n.match(/.{4}/g).join(" ");
    },
    paymentYearDisplay() {
      return this.PaymentForm.ExpirationYear
        ? this.PaymentForm.ExpirationYear.toString().slice(-2)
        : "YY";
    },
  },

  methods: {
    // ── Segment gruplama ────────────────────────────────────────────────────
    getLegs(segments) {
      if (!segments || !segments.length) return [];
      if (segments.length === 1) return [segments];
      const firstDep = segments[0].DepartureAirportCode;
      const lastArr = segments[segments.length - 1].ArrivalAirportCode;
      if (firstDep === lastArr) {
        const mid = Math.ceil(segments.length / 2);
        return [segments.slice(0, mid), segments.slice(mid)];
      }
      return [segments];
    },

    updatePassengerAdres(pax, index) {
      if (this.isContactDefault === index) {
        this.updatePassengerItem.Contact.Name = pax.FirstName;
        this.updatePassengerItem.Contact.LastName = pax.LastName;
        this.updatePassengerItem.Contact.Phone = pax.Phone;
        this.updatePassengerItem.Contact.Email = pax.Email
      }
      else if (this.isContactDefault === -1 && index === 0) {
        this.updatePassengerItem.Contact.Name = pax.FirstName;
        this.updatePassengerItem.Contact.LastName = pax.LastName;
        this.updatePassengerItem.Contact.Phone = pax.Phone;
        this.updatePassengerItem.Contact.Email = pax.Email
        this.isContactDefault = index;
      }
      const updatedPax = {
        ...this.paxList[index], // Mevcut olan tüm özellikleri (ad, soyad vb.) kopyala
        ...pax                  // Sadece değişen özellikleri (örn: adres) üzerine yaz
      };
      this.$set(this.paxList, index, updatedPax);
    },

    paxChipClass(paxCode) {
      if (paxCode === "ADT") return "chip-adult";
      if (paxCode === "CHD") return "chip-child";
      return "chip-infant";
    },

    // ── Arkman Bilet Kontrolü ───────────────────────────────────────────────
    searchTicketNo() {
      const credentials = JSON.parse(window.localStorage.getItem("credentials"));
      this.ListInput.BiletNo = this.ticketAllocate[0].PassengerBreakdowns[0].TicketNumber.substring(3);
      this.ListInput.BaslangicTarihi = this.ticketAllocate[0].FlightSegments[0].DepartureDate;
      this.ListInput.BitisTarihi = this.ticketAllocate[0].FlightSegments[0].DepartureDate;
      this.ListInput.SirketKodu = credentials.SirketKodu.toString();
      this.ListInput.Paging.SayfaNo = 1;
      this.$http.post(auth.API_URL + "api/Ticket/TicketList", this.ListInput, {
        headers: { Authorization: "Bearer " + auth.getAuthHeader() },
      }).then(
        (response) => { this.nextStatu = response.body.length === 1; },
        () => { this.nextStatu = false; }
      );
    },

    async imageUrlToBase64(url) {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    // ── Provider ────────────────────────────────────────────────────────────
    getProviders() {
      this.prmAcenteKodu = null;
      const bookingParams = JSON.parse(window.localStorage.getItem("bookingParams"));
      this.$http.post(auth.BOOKING_API_URL + "Agency/GetCredential",
        { SessionHeader: { SessionId: bookingParams.SessionId, SessionToken: bookingParams.SessionToken } },
        { headers: { Authorization: "Bearer " + auth.getAuthHeader() } }
      ).then(
        (response) => {
          (response.body.Credentials || []).forEach((el) => {
            if (el.ProviderType === "Air" && el.Provider === "Turna") {
              this.prmAcenteKodu = el.OfficeId;
              this.itemsproviders.push({ Id: el.Id, Provider: el.Provider, ProviderType: el.ProviderType, OfficeId: el.OfficeId });
            }
          });
        },
        () => { this.text1 = "GetCredential - Service Unavailable"; this.snackbar = true; }
      );
    },

    // ── Kart ödeme onayı ───────────────────────────────────────────────────
    confirmthereed() {
      this.threedConfirmDialog = true;
    },

    creditCardPayment() {
      this.threedConfirmDialog = false;
      if (this.$refs.formodeme.validate()) {
        this.creditCardInfo = false;
        this.makePaymentItem.PaymentType = "CreditCardPayment";
        this.makePaymentItem.PayableBank = "5";
        this.makePayment();
      }
    },

    // ── KK buton (yeni: updatePassenger flow, update: prebook flow) ────────
    updatePassengerCard(val, mode) {
      if (this.Provider === "Turna" && !this.prmAcenteKodu) {
        alert("Turna Acente Kodu Bulunamadı..");
        return;
      }
      if (this.step === 0) {
        if (mode === "payment") {
          this.startPaymentWithPrebook(val);
        } else {
          this.updatePassenger(val);
        }
      }
      else {
        if (this.typeOfPayment === 2) this.currentPayInfo = true;
        else if (this.typeOfPayment === 3) this.creditCardInfo = true;
      }

    },

    // ── isUpdate cari/KK için prebook başlatma ─────────────────────────────
    startPaymentWithPrebook(val) {
      console.log("step", this.step, "typeofpayment", this.typeOfPayment)

      if (this.step > 0) {
        if (this.typeOfPayment === 2) this.currentPayInfo = true;
        else if (this.typeOfPayment === 3) this.creditCardInfo = true;
        return;
      }
      if (!this.cariItem) {
        this.text1 = "Lütfen fatura bilgisi seçin";
        this.snackbar = true;
        return;
      }
      this.loadingvmodel = true;
      const credentials = JSON.parse(window.localStorage.getItem("credentials"));
      this.$http.post(auth.API_URL + "api/Current/Get",
        { Code: this.cariItem, CompanyCode: credentials.SirketKodu },
        { headers: { Authorization: "Bearer " + auth.getAuthHeader() } }
      ).then(
        (response) => {
          this.CurrentCode = response.body.Code;
          this.billingInformationItem.BillingInformation.BillingName = response.body.Title;
          this.billingInformationItem.BillingInformation.Address = response.body.Invoice.Address;
          this.billingInformationItem.BillingInformation.City = response.body.Invoice.Province;
          this.billingInformationItem.BillingInformation.TaxOffice = response.body.Invoice.TaxOffice;
          this.billingInformationItem.BillingInformation.TaxNo = response.body.Invoice.TaxNumber;
          this.billingSubmit(val);
        },
        () => { this.text1 = "Cari bilgi alınamadı"; this.snackbar = true; this.loadingvmodel = false; }
      );
    },

    // ── İletişim sync yardımcıları ─────────────────────────────────────────
    changePhone(phone) { this.updatePassengerItem.Contact.Phone = phone; },
    changeEmail(email) { if (this.paxList.length === 1) this.updatePassengerItem.Contact.Email = email; },
    changeLastName(lastName) { if (this.paxList.length === 1) this.updatePassengerItem.Contact.LastName = lastName; },
    changeFirstName(firstName) { if (this.paxList.length === 1) this.updatePassengerItem.Contact.Name = firstName; },

    defaultContact(contact, index) {
      if (this.isContactDefault !== index && this.contactValueList[index]) {
        this.updatePassengerItem.Contact.Name = contact.FirstName;
        this.updatePassengerItem.Contact.LastName = contact.LastName;
        this.updatePassengerItem.Contact.Phone = contact.Phone;
        this.updatePassengerItem.Contact.Email = contact.Email;
        this.isContactDefault = index;
      } else {
        this.updatePassengerItem.Contact.Name = "";
        this.updatePassengerItem.Contact.LastName = "";
        this.updatePassengerItem.Contact.Phone = "";
        this.updatePassengerItem.Contact.Email = "";
        this.isContactDefault = -1;
      }
    },

    // ── Rezervasyon İptal ──────────────────────────────────────────────────
    cancelReservation() {
      this.loadingvmodel = true;
      const bookingParams = JSON.parse(window.localStorage.getItem("bookingParams"));
      this.$http.post(auth.BOOKING_API_URL + "Air/CancelReservation", {
        SessionHeader: { SessionId: bookingParams.SessionId, SessionToken: bookingParams.SessionToken },
        bookingData: { locator: this.$route.query.pnr },
        ShoppingCartId: window.localStorage.getItem("shopCartID"),
      }).then(
        (response) => {
          if (!response.body.HasError) {
            this.loadingvmodel = false;
            this.text1 = "Rezervasyon iptal edildi";
            this.snackbar = true;
            setTimeout(() => { window.open("#/satis/ucus/rezervasyonliste", "_self"); }, 1250);
          } else {
            this.text1 = response.body.ServiceError.ErrorMessages[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        () => { this.text1 = "Service Unavailable-Air/CancelReservation"; this.snackbar = true; this.loadingvmodel = false; }
      );
    },

    // ── Cari arama (isUpdate: BillingInfo'yu ayarlar) ──────────────────────
    searchBillingInfo(val) {
      this.$http.post(auth.API_URL + "api/options/CurrentSearch",
        { q: val, Coper: false },
        { headers: { Authorization: "Bearer " + auth.getAuthHeader() } }
      ).then(
        (response) => { this.cariItem = response.body[0].id; },
        (response) => { this.text1 = response.statusText; this.snackbar = true; }
      );
    },

    // ── Fatura bilgisi getir ───────────────────────────────────────────────
    getBillingInfo() {
      const credentials = JSON.parse(window.localStorage.getItem("credentials"));
      this.$http.post(auth.API_URL + "api/Current/Get",
        { Code: this.cariItem, CompanyCode: credentials.SirketKodu },
        { headers: { Authorization: "Bearer " + auth.getAuthHeader() } }
      ).then(
        (response) => {
          this.CurrentCode = response.body.Code;
          this.billingInformationItem.BillingInformation.BillingName = response.body.Title;
          this.billingInformationItem.BillingInformation.Address = response.body.Invoice.Address;
          this.billingInformationItem.BillingInformation.City = response.body.Invoice.Province;
          this.billingInformationItem.BillingInformation.TaxOffice = response.body.Invoice.TaxOffice;
          this.billingInformationItem.BillingInformation.TaxNo = response.body.Invoice.TaxNumber;
        },
        (response) => { this.text1 = response.statusText; this.snackbar = true; }
      );
    },

    // ── Fatura gönder ──────────────────────────────────────────────────────
    billingSubmit(val) {
      this.loadingvmodel = true;
      const bookingParams = JSON.parse(window.localStorage.getItem("bookingParams"));
      this.billingInformationItem.SessionHeader.SessionId = bookingParams.SessionId;
      this.billingInformationItem.SessionHeader.SessionToken = bookingParams.SessionToken;
      this.billingInformationItem.ShoppingCartId = window.localStorage.getItem("shopCartID");
      this.$http.post(auth.BOOKING_API_URL + "Billing/Submit", this.billingInformationItem).then(
        (response) => {
          if (!response.body.HasError) {
            this.makePrebooking(val);
          } else {
            this.text1 = response.body.ServiceError.ErrorMessages[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        () => { this.text1 = "Service Unavailable-Billing/Submit"; this.snackbar = true; this.loadingvmodel = false; }
      );
    },

    // ── Ödeme yap ──────────────────────────────────────────────────────────
    makePayment() {
      if (this.Provider === "Turna" && !this.prmAcenteKodu) {
        alert("Turna Acente Kodu Bulunamadı..");
        return;
      }
      this.currentPayInfo = false;
      const bookingParams = JSON.parse(window.localStorage.getItem("bookingParams"));
      this.loadingvmodel = true;
      this.makePaymentItem.SessionHeader.SessionId = bookingParams.SessionId;
      this.makePaymentItem.SessionHeader.SessionToken = bookingParams.SessionToken;
      this.makePaymentItem.ShoppingCartId = window.localStorage.getItem("shopCartID");
      this.makePaymentItem.Amount = this.footerTotalFare;
      if (this.makePaymentItem.PaymentType === "CreditCardPayment") {
        this.PaymentForm.ExpirationYear = this.PaymentForm.ExpirationYear.slice(-2);
        this.makePaymentItem.PaymentForm = this.PaymentForm;
        this.makePaymentItem.PaymentForm.InstallmentId = this.makePaymentItem.ShoppingCartId;
      }
      this.$http.post(auth.BOOKING_API_URL + "MakePayment", this.makePaymentItem).then(
        (response) => {
          if (!response.body.HasError) {
            this.finalizeShopping();
          } else {
            this.text1 = response.body.ServiceError.ErrorMessages[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        () => { this.text1 = "Service Unavailable-MakePayment"; this.snackbar = true; this.loadingvmodel = false; }
      );
    },

    // ── Ödeme tamamla ──────────────────────────────────────────────────────
    finalizeShopping() {
      const bookingParams = JSON.parse(window.localStorage.getItem("bookingParams"));
      this.finalizeShoppingItem.SessionHeader.SessionId = bookingParams.SessionId;
      this.finalizeShoppingItem.SessionHeader.SessionToken = bookingParams.SessionToken;
      this.finalizeShoppingItem.ShoppingCartId = window.localStorage.getItem("shopCartID");
      this.$http.post(auth.BOOKING_API_URL + "Air/FinalizeShopping", this.finalizeShoppingItem).then(
        (response) => {
          if (!response.body.HasError) {
            this.sendNextTicket(response.body.ShoppingCart);
          } else {
            this.text1 = response.body.ServiceError.ErrorMessages[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
          this.text1 = (response.body && response.body.ServiceError)
            ? response.body.ServiceError.ErrorMessages[0]
            : "Service Unavailable-Air/FinalizeShopping";
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },

    // ── Ön rezervasyon / bilet akışı ───────────────────────────────────────
    // val: 1=yalnızca rezervasyon, 2=cari ödeme, 3=KK ödeme
    makePrebooking(val) {
      this.loadingvmodel = true;
      const bookingParams = JSON.parse(window.localStorage.getItem("bookingParams"));
      this.makePrebookingItem.ContinueWithoutReservation = val !== 1;
      this.makePrebookingItem.SessionHeader.SessionId = bookingParams.SessionId;
      this.makePrebookingItem.SessionHeader.SessionToken = bookingParams.SessionToken;
      this.makePrebookingItem.ShoppingCartId = window.localStorage.getItem("shopCartID");
      this.$http.post(auth.BOOKING_API_URL + "Air/MakePrebooking", this.makePrebookingItem).then(
        (response) => {
          if (!response.body.HasError) {
            if (val === 1) {
              this.loadingvmodel = false;
              this.text1 = "Ön Rezervasyon İşlemi Tamamlandı.";
              this.snackbar = true;
              this.snackbarkColor = "success";
              var url = "#/satis/ucus/islem/id?islem=get&pnr=" + response.body.ShoppingCart.AirBookings[0].BookingCode;
              window.open(url, "_self");
              window.location.reload();
              return;
            }
            if (response.body.ShoppingCart) {
              const summary = response.body.ShoppingCart.ShoppingSummary;
              if (response.body.ShoppingCart.IsPriceChanged) {
                this.calculateFooter(summary, this.searchCurrency);
                this.priceChanged = true;
                this.text1 = this.$t('pricechanged') + "!";

                this.snackbar = true;
              }
              this.loadingvmodel = false;
              this.text1 = this.$t('prebookingdone');
              this.snackbar = true;

              this.prebookingDone = true;
              this.passengersLocked = true;
              this.disabled = true;
              this.paymentInfo = val;

              this.typeOfPayment = val;
              if (val === 2) this.currentPayInfo = true;
              else if (val === 3) this.creditCardInfo = true;
            } else {
              this.text1 = this.$t('shoppingcartnotreadable');
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          } else {
            this.text1 = response.body.ServiceError.ErrorMessages[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
          this.text1 = (response.body && response.body.ServiceError)
            ? response.body.ServiceError.ErrorMessages[0]
            : "Service Unavailable-Air/MakePrebooking";
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },

    // ── Yolcu güncelle + akış başlat ──────────────────────────────────────
    // val: 1=rez, 2=cari, 3=KK
    updatePassenger(val) {
      this.paymentInfo = val;
      if (this.prebookingDone) {
        if (this.paymentInfo === 2) this.currentPayInfo = true;
        else if (this.paymentInfo === 3) this.creditCardInfo = true;
        return;
      }

      console.log("step", this.step, "typeofpayment", this.typeOfPayment)
      if (this.step > 0) {
        if (this.typeOfPayment === 2) this.currentPayInfo = true;
        else if (this.typeOfPayment === 3) this.creditCardInfo = true;
        return;
      }
      if (this.isInternational) {
        const missing = this.paxList.some((p) => !p.PassportNo || !p.PassportExpireDate);
        if (missing) {
          this.text1 = this.$t("Please-fill-in-the-required-fields.");
          this.snackbar = true;
          return;
        }
        this.paxList.forEach((p) => { if (!p.CitizenNo) p.CitizenNo = "00000000000"; });
      }
      if (!this.$refs.formTicket.validate()) {
        this.text1 = this.$t("Please-fill-in-the-required-fields.");
        this.snackbar = true;
        return;
      }
      if (!this.cariItem) {
        this.text1 = "Lütfen fatura bilgisi seçin.";
        this.snackbar = true;
        return;
      }
      this.loadingvmodel = true;
      this.getBillingInfo();

      const bookingParams = JSON.parse(window.localStorage.getItem("bookingParams"));
      const params = JSON.parse(JSON.stringify(this.updatePassengerItem));
      params.SessionHeader.SessionId = bookingParams.SessionId;
      params.SessionHeader.SessionToken = bookingParams.SessionToken;
      params.Passengers = this.paxList;
      params.ShoppingCartId = window.localStorage.getItem("shopCartID");

      params.Passengers.forEach((p) => {
        p.BirthDate = p.BirthDate.split("T")[0];
        if (!p.PassportExpireDate || p.PassportExpireDate === "0001-01-01T00:00:00") {
          p.PassportExpireDate = new Date();
        }
      });

      this.$http.post(auth.BOOKING_API_URL + "Air/UpdatePassengers", params).then(
        (response) => {
          if (!response.body.HasError) {
            this.loadingvmodel = false;
            //this.addPassengerstoCoper(params.Passengers);
            this.billingSubmit(val);
          } else {
            this.text1 = response.body.ServiceError.ErrorMessages[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
          this.text1 = (response.body && response.body.ServiceError)
            ? response.body.ServiceError.ErrorMessages[0]
            : "Service Unavailable-Air/UpdatePassengers";
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },

    // ── Coper'a yolcu kaydet ───────────────────────────────────────────────


    // ── Footer hesaplama ───────────────────────────────────────────────────
    toNumber(val) {
      if (val == null) return 0;
      return parseFloat(val.toString().replace(/,/g, "")) || 0;
    },

    calculateFooter() {
      this.footerBaseFare = 0;
      this.footerTotalTax = 0;
      this.footerTotalServiceFee = 0;
      this.footerLateInterest = 0;
      this.footerTotalMarkupFare = 0;
      this.footerTotalMarkupFareList = 0;
      this.footerTotalFare = 0;
      (this.ticketAllocate || []).forEach((ticket) => {
        (ticket.PassengerBreakdowns || []).forEach((el) => {
          this.footerBaseFare += this.toNumber(resolvePriceField(el, 'BaseFare', this.searchCurrency));
          this.footerTotalTax += this.toNumber(resolvePriceField(el, 'TotalTax', this.searchCurrency));
          this.footerTotalServiceFee += this.toNumber(resolvePriceField(el, 'TotalServiceFee', this.searchCurrency));
          this.footerLateInterest += this.toNumber(resolvePriceField(el, 'TotalLateInterest', this.searchCurrency));
          this.footerTotalMarkupFare += this.toNumber(resolvePriceField(el, 'TotalMarkupFare', this.searchCurrency));
          this.footerTotalMarkupFareList += this.toNumber(resolvePriceField(el, 'TotalMarkupFareList', this.searchCurrency));
          this.footerTotalFare += this.toNumber(resolvePriceField(el, 'TotalFare', this.searchCurrency));
        });
      });
    },

    // ── Yardımcılar ───────────────────────────────────────────────────────
    formatTicketNumber(ticket) {
      if (!ticket || !ticket.PassengerBreakdowns || !ticket.PassengerBreakdowns.length) return "";
      const n = ticket.PassengerBreakdowns[0].TicketNumber;
      if (!n || n.length <= 3) return n || "";
      return n.substring(0, 3) + "-" + n.substring(3);
    },

    getImgUrl(img) { return logoo.logoControl(img); },
    setCurrency(val) { this.currencyValue = val; },

    maskCardNumber(cardNo) {
      const s = String(cardNo).replace(/\D/g, "");
      if (s.length <= 8) return s;
      return s.slice(0, 4) + "*".repeat(s.length - 8) + s.slice(-4);
    },

    // ── PDF İndir ──────────────────────────────────────────────────────────
    downloadPdf(ticket) {
      this.pdfactive = true;
      this.ShoppingCard = this.ShoppingCard || { AirBookings: [ticket] };
      this.sendNextTicket(this.ShoppingCard);
    },

    // ── Parkur hesapla ────────────────────────────────────────────────────
    buildParkurlar(segments) {
      const get = (i, prop) => (segments[i] ? segments[i][prop] : "");
      switch (segments.length) {
        case 1:
          return { Parkur1: get(0, "DepartureAirportCode"), Parkur2: get(0, "ArrivalAirportCode"), Parkur3: "", Parkur4: "", Parkur5: "" };
        case 2:
          return { Parkur1: get(0, "DepartureAirportCode"), Parkur2: get(0, "ArrivalAirportCode"), Parkur3: get(1, "ArrivalAirportCode"), Parkur4: "", Parkur5: "" };
        case 3:
          return { Parkur1: get(0, "DepartureAirportCode"), Parkur2: get(0, "ArrivalAirportCode"), Parkur3: get(1, "ArrivalAirportCode"), Parkur4: get(2, "ArrivalAirportCode"), Parkur5: "" };
        case 4:
          return { Parkur1: get(0, "DepartureAirportCode"), Parkur2: get(0, "ArrivalAirportCode"), Parkur3: get(1, "ArrivalAirportCode"), Parkur4: get(1, "DepartureAirportCode"), Parkur5: get(3, "ArrivalAirportCode") };
        default: {
          const dir0 = segments.find((x) => x.DirectionInd === 0);
          const dir1 = segments.find((x) => x.DirectionInd === 1);
          return {
            Parkur1: get(0, "DepartureAirportCode"),
            Parkur2: get(0, "ArrivalAirportCode"),
            Parkur3: dir0 ? dir0.ArrivalAirportCode : "",
            Parkur4: dir1 ? dir1.DepartureAirportCode : "",
            Parkur5: dir1 ? dir1.ArrivalAirportCode : "",
          };
        }
      }
    },

    closeCreditCardDialog() {
      this.creditCardInfo = false;
      this.loadingvmodel = false;
      this.step = 4;
      this.disabled = true;
      this.typeOfPayment = 3;
    },
    closeCurrentPaymentDialog() {
      this.currentPayInfo = false;
      this.loadingvmodel = false;
      this.step = 4;
      this.disabled = true
      this.typeOfPayment = 2
    },

    // ── Arkman'da göster (biletleme yapılmış) ─────────────────────────────
    goNextTicket(val) {
      this.loadingvmodel = true;
      const credentials = JSON.parse(window.localStorage.getItem("credentials"));
      this.nextTicket.GenelBilgileri.SirketKodu = credentials.SirketKodu;
      val.AirBookings.forEach((element) => {
        for (let index = 0; index < element.PassengerBreakdowns.length; index++) {
          const breakdown = element.PassengerBreakdowns[index];
          this._fillNextTicket(element, breakdown, val, credentials, index);
          const url = "#/bilet/yeni/id?isl=get&hyolukod=" + this.nextTicket.GenelBilgileri.HavaYoluKodu +
            "&biletno=" + this.nextTicket.GenelBilgileri.BiletNo +
            "&ucustipi=" + this.nextTicket.GenelBilgileri.UcusTipi + "&tab=0";
          location.href = url;
          location.reload();
        }
      });
    },

    // ── Ortak nextTicket doldurma ──────────────────────────────────────────
    _fillNextTicket(element, breakdown, val, credentials, index) {
      const isDomestic = element.FlightSegments[0].DepartureCountryName === element.FlightSegments[0].ArrivalCountryName;
      const bookingcode = element.BookingCode;

      if (breakdown.TicketNumber.includes(bookingcode)) {
        this.nextTicket.GenelBilgileri.BiletNo = "0";
        this.nextTicket.otomatikBiletNo = true;
        this.nextTicket.GenelBilgileri.HavaYoluKodu = element.FlightSegments[0].MarkettingAirline;
      } else {
        this.nextTicket.GenelBilgileri.BiletNo = breakdown.TicketNumber.substring(3);
        this.nextTicket.GenelBilgileri.Formno = breakdown.TicketNumber.substring(0, 3);
        this.nextTicket.GenelBilgileri.HavaYoluKodu = element.FlightSegments[0].MarkettingAirline;
      }
      
      this.nextTicket.GenelBilgileri.Acente = "";
      this.nextTicket.GenelBilgileri.AcenteKodu = "";
      if (this.Provider === "Turna") {
        this.nextTicket.GenelBilgileri.Acente = "A";
        this.nextTicket.GenelBilgileri.AcenteKodu = this.prmAcenteKodu;
      }
      this.nextTicket.GenelBilgileri.ArkmanUsers = "WEB";
      this.nextTicket.GenelBilgileri.Crs = "ArkmanAktarim";

      if (this.makePaymentItem.PaymentType === "CreditCardPayment") {
        this.nextTicket.OdemeBilgileri.SatisSekli = "F";
        this.nextTicket.OdemeBilgileri.KomisyonTip = "K";
        this.nextTicket.OdemeBilgileri.KrediKartBilgi.KrediKartNo = this.maskCardNumber(this.PaymentForm.CardNumber);
        this.nextTicket.OdemeBilgileri.KrediKartBilgi.KrediKartTip = "F";
      }

      this.nextTicket.GenelBilgileri.UcusTipi = isDomestic ? "I" : "D";
      this.nextTicket.TanimBilgileri.ServisKod = isDomestic ? "11" : "21";

      if (this.$route.query.islem === "new") this.nextTicket.GenelBilgileri.MusteriKodu.Kod = this.CurrentCode;
      this.nextTicket.GenelBilgileri.MusteriKodu.Unvan = val.BillingInformation.BillingName;

      const analysisprice = breakdown.TotalMarkupFare + breakdown.TotalMarkupFareList;
      this.nextTicket.TutarBilgileri.NetTutar.NetTutar = this.footerTotalFare;
      if (isDomestic) {
        this.nextTicket.TutarBilgileri.AlanVergiTutar.AlanVergiTutar = this.footerTotalTax;
      } else {
        this.nextTicket.TutarBilgileri.TaxTutar.TaxTutar = this.footerTotalTax;
      }
      this.nextTicket.TutarBilgileri.ServisTutar.ServisTutar = this.footerTotalMarkupFare;
      this.nextTicket.TutarBilgileri.Tutar.Tutar = this.footerBaseFare;
      this.nextTicket.NotlarBilgileri.RefFare = this.footerBaseFare;
      this.nextTicket.NotlarBilgileri.LowFare = this.footerBaseFare - this.footerTotalMarkupFare;
      if (credentials.ParaBirimi && this.searchCurrency && credentials.ParaBirimi !== this.searchCurrency) {
        const currencyMap = Array.isArray(breakdown.CurrencyMaps)
          ? breakdown.CurrencyMaps.find((m) => m.Currency === this.searchCurrency)
          : null;
        this.nextTicket.TutarBilgileri.Doviz.DovizKod = this.searchCurrency;
        this.nextTicket.TutarBilgileri.Kur = currencyMap ? currencyMap.Rate : 1;
      } else {
        this.nextTicket.TutarBilgileri.Doviz.DovizKod = breakdown.Currency;
        this.nextTicket.TutarBilgileri.Kur = 1;
      }
      this.nextTicket.TanimBilgileri.AnalizKod.AnalizTutar = analysisprice;
      this.nextTicket.TanimBilgileri.AnalizKod.AnalizKod = "KOM";
      this.nextTicket.TarihBilgileri.SatisTarihi = helpers.getDateNow();
      this.nextTicket.TarihBilgileri.OdemeTarihi = helpers.getDateNow();

      const parkurlar = this.buildParkurlar(element.FlightSegments);
      Object.assign(this.nextTicket.GenelBilgileri.Parkurlar, parkurlar);
      this.nextTicket.GenelBilgileri.PnrNo = element.BookingCode;

      const fsCount = element.FlightSegments.length;
      const ow = fsCount === 1;
      const rt = !ow && element.FlightSegments[0].DepartureAirportCode === element.FlightSegments[fsCount - 1].ArrivalAirportCode;
      this.nextTicket.GenelBilgileri.BiletYon = ow ? "T" : rt ? "C" : "T";

      this.nextTicket.UcusBilgileri = {};
      this.nextTicket.UcusBilgileri.UcusListesi = [];
      this.nextTicket.UcusBilgileri.UcusTarihi = element.FlightSegments[0].DepartureDateTime;
      if (rt && fsCount > 1) {
        this.nextTicket.UcusBilgileri.UcusDonusTarihi = element.FlightSegments[fsCount - 1].DepartureDateTime;
      }
      var fareBilgileri = this.fareBilgileriGetir(element);
      console.log(fareBilgileri);
      let segCount = 0;
      for (const ucus of element.FlightSegments) {
        var farebilgisi = fareBilgileri[segCount];
        this.nextTicket.UcusBilgileri.UcusListesi.push({
          Aktarma: ucus.IsConnected,
          BiletNo: this.nextTicket.GenelBilgileri.BiletNo,
          FareBases: breakdown.BaseFare,
          Formno: this.nextTicket.GenelBilgileri.Formno,
          Parkur: ucus.DepartureAirportCode,
          VarisParkur: ucus.ArrivalAirportCode,
          ParkurNo: index + 1,
          SirketKodu: credentials.SirketKodu,
          UcusClass: ucus.BookingClass,
          UcusClassTip: ucus.CabinType,
          UcusHY: ucus.MarkettingAirline,
          UcusNo: ucus.FlightNumber.slice(-4),
          UcusSaat: ucus.DepartureTime,
          UcusTarihi: ucus.DepartureDateTime,
          VarisSaat: ucus.ArrivalTime,
          VarisTarihi: ucus.ArrivalDateTime,
          ExAciklamalarUcus: [{
            BiletNo: this.nextTicket.GenelBilgileri.BiletNo, HavayoluKodu: ucus.MarkettingAirline,
            IadeSartlari: farebilgisi ? farebilgisi.Iade : "İade Yok", IptalSartlari: farebilgisi ? farebilgisi.Iptal : "İptal Yok", KabinBagaj: farebilgisi ? farebilgisi.CarryOnBaggage : "0 KG",
            SirketKodu: credentials.SirketKodu,
            UcusIndex: index + 1, YemekAciklama: farebilgisi ? farebilgisi.Yemek : "", YemekDurumu: farebilgisi ? 1 : 0, Bagaj: farebilgisi ? farebilgisi.CheckedBaggage : "0 KG"
          }],
        });
        segCount++;
      }
      if (segCount === 1) {
        var farebilgisi = fareBilgileri[0];
        const ucus = element.FlightSegments[0];
        this.nextTicket.UcusBilgileri.UcusListesi.push({
          Aktarma: false, BiletNo: this.nextTicket.GenelBilgileri.BiletNo, FareBases: 0,
          Formno: this.nextTicket.GenelBilgileri.Formno, Parkur: ucus.ArrivalAirportCode, VarisParkur: "",
          ParkurNo: 2, SirketKodu: credentials.SirketKodu, UcusClass: null, UcusClassTip: null,
          UcusHY: ucus.MarkettingAirline, UcusNo: ucus.FlightNumber.slice(-4), UcusSaat: null,
          UcusTarihi: null, VarisSaat: null, VarisTarihi: null,
          ExAciklamalarUcus: [{
            BiletNo: this.nextTicket.GenelBilgileri.BiletNo, HavayoluKodu: ucus.MarkettingAirline,
            IadeSartlari: farebilgisi ? farebilgisi.Iade : "İade Yok", IptalSartlari: farebilgisi ? farebilgisi.Iptal : "İptal Yok",
            KabinBagaj: farebilgisi ? farebilgisi.CarryOnBaggage : "0 KG", SirketKodu: credentials.SirketKodu, UcusIndex: 2,
            YemekAciklama: farebilgisi ? farebilgisi.Yemek : "", YemekDurumu: farebilgisi ? 1 : 0, Bagaj: farebilgisi ? farebilgisi.CheckedBaggage : "0 KG"
          }],
        });
      }

      const passenger = val.Passengers.find((x) => x.PaxReferanceId === breakdown.PaxReference.PaxReferanceId);
      if (passenger) {
        this.nextTicket.GenelBilgileri.YolcuAdi = passenger.FirstName + " " + passenger.LastName;
        this.nextTicket.GenelBilgileri.FiyatTur = passenger.PaxType;
        this.nextTicket.GenelBilgileri.HesKodu = passenger.HesCode;
      }
      this.nextTicket.GenelBilgileri.Email = this.updatePassengerItem.Contact.Email;
      this.nextTicket.GenelBilgileri.BiletTel = this.updatePassengerItem.Contact.Phone;
      this.nextTicket.OdemeBilgileri.MakbuzNo = breakdown.TicketNumber;
    },

    // ── Uçuş listesini güncelle (otomatik bilet no) ────────────────────────
    updateucuslist(ticket) {
      ticket.UcusBilgileri.UcusListesi.forEach((ucus) => {
        ucus.BiletNo = this.nextTicket.GenelBilgileri.BiletNo;
        ucus.Formno = this.nextTicket.GenelBilgileri.Formno;
        if (ucus.ExAciklamalarUcus && ucus.ExAciklamalarUcus[0]) {
          ucus.ExAciklamalarUcus[0].BiletNo = this.nextTicket.GenelBilgileri.BiletNo;
        }
      });
      this.$http.post(auth.API_URL + "api/Ticket/TicketAddAndLoad", this.nextTicket, {
        headers: { Authorization: "Bearer " + auth.getAuthHeader() },
      }).then(
        (response) => {
          this.text1 = this.$t(response.body.ResponseMessage);
          this.snackbar = true;
          this.loadingvmodel = false;
          if (response.body.Status) {
            setTimeout(() => {
              const url = "#/bilet/yeni/id?isl=get&hyolukod=" + this.nextTicket.GenelBilgileri.HavaYoluKodu +
                "&biletno=" + this.nextTicket.GenelBilgileri.BiletNo +
                "&ucustipi=" + this.nextTicket.GenelBilgileri.UcusTipi + "&tab=0";
              location.href = url;
              location.reload();
            }, 3000);
          }
        },
        () => { this.text1 = "Service Unavailable"; this.snackbar = true; this.loadingvmodel = false; }
      );
    },

    // ── Arkman'a bilet kaydet ──────────────────────────────────────────────
    sendNextTicket(val) {
      this.loadingvmodel = true;
      const credentials = JSON.parse(window.localStorage.getItem("credentials"));
      this.nextTicket.GenelBilgileri.SirketKodu = credentials.SirketKodu;

      val.AirBookings.forEach((element) => {
        for (let index = 0; index < element.PassengerBreakdowns.length; index++) {
          const breakdown = element.PassengerBreakdowns[index];
          this._fillNextTicket(element, breakdown, val, credentials, index);

          if (!this.pdfactive) {
            this.$http.post(auth.API_URL + "api/Ticket/TicketAddAndLoad", this.nextTicket, {
              headers: { Authorization: "Bearer " + auth.getAuthHeader() },
            }).then(
              (response) => {
                this.loadingvmodel = false;
                this.text1 = response.body.Status ? "Bilet Kayıt İşlemi Tamamlandı." : this.$t(response.body.ResponseMessage);
                this.snackbar = true;
                if (response.body.Status) {
                  this.nextTicket.GenelBilgileri.BiletNo = response.body.Bilet.GenelBilgileri.BiletNo;
                  this.nextTicket.GenelBilgileri.Formno = response.body.Bilet.GenelBilgileri.Formno;
                  if (this.nextTicket.otomatikBiletNo) this.updateucuslist(this.nextTicket);
                  setTimeout(() => {
                    const url = "#/satis/ucus/islem/id?islem=get&pnr=" + this.nextTicket.GenelBilgileri.PnrNo
                    location.href = url;
                    location.reload();
                  }, 3000);
                }
              },
              () => { this.text1 = "Service Unavailable"; this.snackbar = true; this.loadingvmodel = false; }
            );
          } else {
            this.imageUrlToBase64(this.getImgUrl(this.nextTicket.GenelBilgileri.HavaYoluKodu)).then((base64) => {
              this.nextTicket.PdfLang = "tr";
              this.nextTicket.PdfShowAmount = true;
              this.$http.post(auth.API_URL + "api/Ticket/TicketPdfDownload",
                { Bilet: this.nextTicket, logo: base64 },
                {
                  headers: {
                    Authorization: "Bearer " + auth.getAuthHeader(),
                    CariSirketNo: credentials.SirketKodu.toString(),
                    CoperSirketNo: credentials.CoperSirketNo.toString(),
                    MuhasebeSirketNo: credentials.MuhasebeSirketNo.toString(),
                  },
                  responseType: "arraybuffer",
                }
              ).then(
                (response) => {
                  const blob = new Blob([response.data], { type: "application/pdf" });
                  const link = document.createElement("a");
                  link.href = URL.createObjectURL(blob);
                  link.download = "TicketInvoice.pdf";
                  link.click();
                  this.loadingvmodel = false;
                  this.pdfactive = false;
                },
                () => { this.text1 = this.$t("PDF-could-not-be-downloaded"); this.snackbar = true; this.loadingvmodel = false; this.pdfactive = false; }
              );
            });
          }
        }
      });
    },

    // ── Allocate (yeni bilet modu) ─────────────────────────────────────────
    allocated() {
      this.loadingvmodel = true;
      const allocateParams = JSON.parse(window.localStorage.getItem("allocateParams"));
      this.$http.post(auth.BOOKING_API_URL + "Air/Allocate", allocateParams).then(
        (response) => {
          if (!response.body.HasError) {
            const booking = response.body.ShoppingCart.AirBookings[0];
            this.isInternational = booking.IsInternational;
            this.Provider = booking.Provider;
            this.ticketAllocate = response.body.ShoppingCart.AirBookings;
            this.searchCurrency = response.body.ShoppingCart.SearchCurrency || 'TRY';
            window.localStorage.setItem("shopCartID", response.body.ShoppingCart.Id);

            this.passengerList = booking.PassengerBreakdowns;
            this.passengerList.forEach((el) => {
              const passenger = Airports.passenger();
              passenger.WheelChairService = 0;
              passenger.PaxType = el.PaxReference.PaxCode;
              passenger.PaxReferanceId = el.PaxReference.PaxReferanceId;
              this.paxList.push(passenger);
            });
            this.loadingvmodel = false;
            this.calculateFooter();
          } else {
            this.text1 = response.body.ServiceError.ErrorMessages[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        () => { this.text1 = "Service Unavailable-Air/Allocate"; this.snackbar = true; this.loadingvmodel = false; }
      );
    },
    fareBilgileriGetir(booking) {
      console.log(booking, "booking farebilgilerigetir");
      var bilgiler = []
      if (booking.Provider === "Pegasus") {
        console.log("pegasus booking", booking);
        booking.SelectedFares.forEach((fare) => {
          var carryOnBaggage = fare.CarryOnBaggageAllowance ? fare.CarryOnBaggageAllowance.Pieces + " x " + fare.CarryOnBaggageAllowance.Kilos + " kg" : "0";
          var checkedBaggage = fare.CheckedBaggageAllowance ? fare.CheckedBaggageAllowance.Pieces + " x " + fare.CheckedBaggageAllowance.Kilos + " kg" : "0";
          bilgiler.push({
            Iptal: fare.FareCode.toUpperCase().trim() === "COMFORT FLEX" ? "Esnek İptal" : "İptal Yok",
            Iade: fare.FareCode.toUpperCase().trim() === "COMFORT FLEX" ? "Esnek İade" : "İade Yok",
            CarryOnBaggage: carryOnBaggage,
            CheckedBaggage: checkedBaggage,
            Yemek: fare.FareCode.toUpperCase().trim() === "COMFORT FLEX" || fare.FareCode.toUpperCase().trim() === "AVANTAJ" ? "Sandviç İkramı" : "Yemek Yok",
          });
        });
      }
      if (booking.Provider === "Turna") {
        console.log("turna booking", booking);
        booking.SelectedFares.forEach((fare) => {
          var carryOnBaggage = fare.CarryOnBaggageAllowance ? fare.CarryOnBaggageAllowance.Pieces + " x " + fare.CarryOnBaggageAllowance.Kilos + " kg" : "0";
          var checkedBaggage = fare.CheckedBaggageAllowance ? fare.CheckedBaggageAllowance.Pieces + " x " + fare.CheckedBaggageAllowance.Kilos + " kg" : "0";
          bilgiler.push({
            Iptal: fare.Details.filter(x => x.toLowerCase().Contains("değişiklik")).length > 0 ? fare.Details.filter(x => x.toLowerCase().Contains("değişiklik"))[0] : "İptal Yok",
            Iade: fare.Details.filter(x => x.toLowerCase().Contains("iade")).length > 0 ? "Esnek İade" : "İade Yok",
            CarryOnBaggage: carryOnBaggage,
            CheckedBaggage: checkedBaggage,
            Yemek: fare.Details.filter(x => x.toLowerCase().Contains("sandviç") || x.toLowerCase().Contains("yemek")).length > 0 ? fare.Details.filter(x => x.toLowerCase().Contains("sandviç") || x.toLowerCase().Contains("yemek"))[0] : "Yemek Yok",
          });
        });
      }
      else {
        booking.SelectedFares.forEach((fare) => {
          console.log(fare, "fare");
          var carryOnBaggage = fare.CarryOnBaggageAllowance ? fare.CarryOnBaggageAllowance.Pieces + " x " + fare.CarryOnBaggageAllowance.Kilos + " kg" : "0";
          var checkedBaggage = fare.CheckedBaggageAllowance ? fare.CheckedBaggageAllowance.Pieces + " x " + fare.CheckedBaggageAllowance.Kilos + " kg" : "0";
          var changePenalty = null;
          var refundPenalty = null;
          var yemek = null;
          if (fare.Penalties && fare.Penalties.ChangePenalties.length > 0) {
            changePenalty = fare.Penalties.ChangePenalties.filter(x => x.Penalty.toLowerCase().Contains("değişiklik"))[0];
          }
          if (fare.Penalties && fare.Penalties.CancellationPenalties.length > 0) {
            refundPenalty = fare.Penalties.RefundPenalties.filter(x => x.Penalty.toLowerCase().Contains("iade"))[0];
          }
          if (fare.Details && fare.Details.length > 0) {
            yemek = fare.Details.filter(x => x.toLowerCase().Contains("sandviç") || x.toLowerCase().Contains("yemek"))[0];
          }
          bilgiler.push({
            Iptal: changePenalty ? changePenalty.Penalty : "İptal Yok",
            Iade: refundPenalty ? refundPenalty.Penalty : "İade Yok",
            CarryOnBaggage: carryOnBaggage,
            CheckedBaggage: checkedBaggage,
            Yemek: yemek ? yemek : "Yemek Yok",
          });
        });
      }
      console.log(bilgiler, "return bilgiler");
      return bilgiler;
    },

    getShoppingCart() {
      var bookingParams = JSON.parse(window.localStorage.getItem("bookingParams"));
      this.$http.post(auth.BOOKING_API_URL + "GetShoppingCart", {
        SessionHeader: { SessionId: bookingParams.SessionId, SessionToken: bookingParams.SessionToken },
        ShoppingCartId: window.localStorage.getItem("shopCartID"),
      }).then(
        (response) => {
          if (!response.body.HasError) {
            this.ShoppingCard = response.body.ShoppingCart;

          } else {
            this.text1 = response.body.ServiceError.ErrorMessages[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        () => { this.text1 = "Service Unavailable-GetShoppingCart"; this.snackbar = true; this.loadingvmodel = false; }
      );
    }
  },

  filters: {
    passengerType(val) { return Airports.passengerType(val); },
    moneyformat(m) { return helpers.moneyformat(m); },
    dateSlice(val) { return val ? val.substring(0, 10) : ""; },
  },

  components: { FlightSidebar, yetkidialog, snackbarcomp, loadingcomp, caricomp, tarihim, doviz, phoneinput, PassengerCard },

  beforeRouteEnter(to, from, next) {
    next((vm) => { vm.prevRoute = from.path; });
  },

  mounted() {
    this.loadingvmodel = true;
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    this.getProviders();

    if (this.sayfayetki.Status !== true) {
      this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then((sonuc) => {
        if (sonuc) window.open("#" + (this.prevRoute || "/"), "_self");
      });
      return;
    }

    if (this.$route.query.islem === "new") {
      this.isUpdate = false;
      this.flightType = window.localStorage.getItem("flightType");
      this.allocated();
      setTimeout(() => {
        this.countryItems.sort((a, b) => {
          if (!a.name || !b.name) return 0;
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
      }, 1500);

    } else {
      this.isUpdate = true;
      const bookingParams = JSON.parse(window.localStorage.getItem("bookingParams"));
      this.$http.post(auth.BOOKING_API_URL + "GetShoppingCart", {
        SessionHeader: { SessionId: bookingParams.SessionId, SessionToken: bookingParams.SessionToken },
        ShoppingCartId: window.localStorage.getItem("shopCartID"),
      }).then(
        (response) => {
          if (!response.body.HasError) {
            this.ShoppingCard = response.body.ShoppingCart;
            const booking = response.body.ShoppingCart.AirBookings[0];
            this.PnrNo = booking.BookingCode;
            this.Provider = booking.Provider;
            this.searchCurrency = response.body.ShoppingCart.SearchCurrency || 'TRY';
            if(!booking.AirBookingStatus){
              this.IsBooking = true;
            }
            else{
              this.IsBooking = booking.AirBookingStatus.IsBooking;
            }
            this.IsCancelable = response.body.ShoppingCart.IsCancelable;
            this.ticketAllocate = response.body.ShoppingCart.AirBookings;
            window.localStorage.setItem("shopCartID", response.body.ShoppingCart.Id);
            this.passengerList = response.body.ShoppingCart.Passengers;
            this.searchBillingInfo(response.body.ShoppingCart.BillingInformation.BillingName);
            this.passengerList.forEach((el) => { this.paxList.push(el); });
            this.updatePassengerItem.Contact = response.body.ShoppingCart.Contact;
            this.updatePassengerItem.Contact.Phone = response.body.ShoppingCart.Contact.Phone.substring(4);
            this.updatePassengerItem.Notes = (response.body.ShoppingCart.Notes || "") +
              "  Rezervasyon Tarihi = " + response.body.ShoppingCart.CreatedAt;
            this.loadingvmodel = false;
            this.calculateFooter();

            if (this.IsBooking) this.searchTicketNo();
          } else {
            this.text1 = response.body.ServiceError.ErrorMessages[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        () => { this.text1 = "Service Unavailable-GetShoppingCart"; this.snackbar = true; this.loadingvmodel = false; }
      );
    }
  },
};
</script>

<style scoped>
/* Layout */
.sticky-sidebar {
  position: sticky;
  top: 16px;
}

/* Header */
.page-header-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 20px 24px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.pnr-chip-badge {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
}

/* Cards */
.section-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 14px;
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 3px solid transparent;
}

.card-header.purple-bar {
  border-top-color: #667eea;
  background: #fafafa;
}

.card-header.green-bar {
  border-top-color: #10b981;
  background: #fafafa;
}

.card-header.amber-bar {
  border-top-color: #f59e0b;
  background: #fafafa;
}

.card-header.grey-bar {
  border-top-color: #9ca3af;
  background: #fafafa;
}

.card-body {
  padding: 14px 16px 4px;
}

/* Passenger badge */
.pax-number-badge {
  width: 28px;
  height: 28px;
  background: #667eea;
  border-radius: 50%;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Flight card */
.flight-card.section-card {
  border-radius: 12px;
  padding: 0;
}

.flight-leg-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid #f3f4f6;
}

.badge-transfer {
  background: #fef3c7;
  color: #d97706;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
}

.badge-direction {
  background: #ede9fe;
  color: #667eea;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
}

.badge-direction.return {
  background: #d1fae5;
  color: #059669;
}

.flight-route-row {
  display: flex;
  align-items: center;
  padding: 14px;
  gap: 8px;
}

.flight-ep {
  flex: 1;
}

.flight-ep.text-right {
  text-align: right;
}

.flight-time {
  font-size: 22px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.1;
}

.flight-iata {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}

.flight-date-label {
  font-size: 11px;
  color: #9ca3af;
}

.flight-mid {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 4px;
}

.dashed-line-left,
.dashed-line-right {
  width: 28px;
  border-top: 2px dashed #d1d5db;
}

.transfer-stop {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: #fffbeb;
}

.pax-price-row {
  padding: 10px 18px;
  border-bottom: 1px solid #f9fafb;
}

.pax-price-row:hover {
  background: #f9fafb;
}

.pax-type-chip {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  margin-bottom: 6px;
}

.chip-adult {
  background: #dbeafe;
  color: #1d4ed8;
}

.chip-child {
  background: #d1fae5;
  color: #065f46;
}

.chip-infant {
  background: #fed7aa;
  color: #92400e;
}

.price-line-item {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #6b7280;
  padding: 1px 0;
}

.price-item-label {
  color: #9ca3af;
}

.pax-subtotal {
  margin-top: 4px;
  font-weight: 600;
  color: #374151;
  font-size: 12px;
}

.grand-total-box {
  padding: 16px 18px;
  border-top: 2px solid #f3f4f6;
  background: #fafafa;
}

/* Action buttons */
.action-card {
  padding: 14px;
}

.action-btn {
  border-radius: 10px !important;
  height: 46px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  margin-bottom: 8px !important;
  box-shadow: none !important;
  font-size: 14px !important;
}

/* Credit card preview */
.cc-card-preview {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  border-radius: 14px;
  padding: 20px;
  color: #fff;
  min-height: 170px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: 'Courier New', monospace;
}

.cc-chip-icon {
  width: 36px;
  height: 28px;
  background: linear-gradient(135deg, #f59e0b, #fbbf24);
  border-radius: 6px;
  margin-bottom: 16px;
}

.cc-number-display {
  font-size: 16px;
  letter-spacing: 2px;
  color: #e2e8f0;
  margin-bottom: 16px;
}

.cc-bottom-row {
  display: flex;
  justify-content: space-between;
}

.cc-meta-label {
  font-size: 9px;
  color: #94a3b8;
  text-transform: uppercase;
}

.cc-meta-value {
  font-size: 13px;
  color: #f1f5f9;
  font-weight: 600;
}
</style>
